import { Component, OnInit, OnDestroy, ViewChild } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { AuthService } from '../../auth/auth.service';
import { ResetPasswordDto } from '../../models/userAccounts/userAccount.models';
import { Subscription } from 'rxjs';
import { ValidateComponent } from '../../components/common/validateComponent/validate.component';

@Component({
    selector: 'account-resetPassword',
    template: require('./resetPassword.component.html'),
    styles: [require('./login.component.css')]
})

export class ResetPasswordComponent extends ValidateComponent implements OnInit, OnDestroy {
    request: ResetPasswordDto;

    routeParamsSub: Subscription;

    @ViewChild('validateForm', { static: false }) currentForm;
    loading: boolean;

    constructor(private router: Router, private authenticationService: AuthService, private route: ActivatedRoute) {
        super();
        this.request = new ResetPasswordDto;

        this.formErrors = {
            'password': '',
            'confirmPassword': '',
        };

        this.validationMessages = {
            'password': {
                'required': 'Password is required.',
                'pattern': 'Password is not valid.'
            },
            'confirmPassword': {
                'validateEqual': 'Passwords do not match.'
            }
        }
    }

    ngOnInit() {
        if (this.routeParamsSub) this.routeParamsSub.unsubscribe();
        this.routeParamsSub = this.route.params.subscribe(params => {
            this.request.token = params['token'];
        });
    }

    ngOnDestroy() {
        if (this.routeParamsSub) this.routeParamsSub.unsubscribe();
    }

    onSubmit() {
        this.loading = true;
        let errors = false;

        if (this.request.password !== this.request.confirmPassword) {
            this.formErrors['confirmPassword'] = 'Passwords do not match.';
            errors = true;
        }

        if (errors) {
            this.loading = false;
            return;
        }

        this.authenticationService.resetPassword(this.request)
            .subscribe(() => this.router.navigateByUrl('/account/login'), () => { this.loading = false; });
    }

    validatePassword() {

        if (this.request.password !== this.request.confirmPassword) {
            this.formErrors['confirmPassword'] = 'Passwords do not match.';
        }
        else {
            this.formErrors['confirmPassword'] = '';
        }

        if (!this.request.password) {
            this.formErrors['password'] = this.validationMessages['password']['required'];
        } else if (!/^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[@!$%^*?&()])[A-Za-z\d@!$%^*?&()]{6,64}$/.test(this.request.password)) {
            this.formErrors['password'] = this.validationMessages['password']['pattern'];
        } else {
            this.formErrors['password'] = '';
        }
    }

}


// WEBPACK FOOTER //
// ./node_modules/angular2-template-loader!./Client/app/views/userAccounts/resetPassword.component.ts